<template>
  <div v-if="dashboard_data.total_sales!=null" class="dash">
    <header class="dash-hero">
      <div class="dash-hero__text">
        <h1 class="dash-hero__title">داشبورد</h1>
        <p class="dash-hero__sub">خلاصه فروش، موجودی و فعالیت فروشگاه</p>
      </div>
    </header>

    <WidgetsDropdown :info="dashboard_data"/>

    <section class="dash-period">
      <div class="dash-period__item dash-period__item--today">
        <span class="dash-period__label">فروش امروز</span>
        <strong class="dash-period__value">{{ get_currency(dashboard_data.today_sales) }}</strong>
        <span class="dash-period__bar"></span>
      </div>
      <div class="dash-period__item dash-period__item--month">
        <span class="dash-period__label">فروش این ماه</span>
        <strong class="dash-period__value">{{ get_currency(dashboard_data.month_sales) }}</strong>
        <span class="dash-period__bar"></span>
      </div>
      <div class="dash-period__item dash-period__item--last">
        <span class="dash-period__label">فروش ماه قبل</span>
        <strong class="dash-period__value">{{ get_currency(dashboard_data.last_month_sales) }}</strong>
        <span class="dash-period__bar"></span>
      </div>
      <div class="dash-period__item dash-period__item--year">
        <span class="dash-period__label">فروش سال</span>
        <strong class="dash-period__value">{{ get_currency(dashboard_data.total_sales) }}</strong>
        <span class="dash-period__bar"></span>
      </div>
    </section>

    <section class="dash-panel">
      <div class="dash-panel__head">
        <div class="dash-panel__title-wrap">
          <span class="dash-panel__icon dash-panel__icon--purple" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 19V5M4 19h16M8 16V10M12 16V7M16 16v-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </span>
          <div>
            <h2 class="dash-panel__title">نمودار فروش</h2>
            <p class="dash-panel__hint">روند فروش روزانه</p>
          </div>
        </div>
        <div class="dash-tabs" role="tablist">
          <button
            type="button"
            v-for="(value, key) in ['روزانه', 'ماهانه', 'سالانه']"
            :key="'sale-' + key"
            class="dash-tabs__btn"
            :class="{ 'is-active': value === selected_sale_time }"
            @click="selected_sale_time = value"
          >
            {{ value }}
          </button>
        </div>
      </div>
      <div class="dash-chart">
        <NewChartJs
          v-if="dashboard_data.dashboard_daily_report"
          type="bar"
          label="فروش"
          :info="dashboard_data.dashboard_daily_report"
        />
      </div>

      <div class="dash-panel__divider"></div>

      <div class="dash-panel__head dash-panel__head--sub">
        <div class="dash-panel__title-wrap">
          <span class="dash-panel__icon dash-panel__icon--teal" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
            </svg>
          </span>
          <div>
            <h2 class="dash-panel__title">نمایش کالاها</h2>
            <p class="dash-panel__hint">بازدید روزانه محصولات</p>
          </div>
        </div>
      </div>
      <div class="dash-chart">
        <NewChartJs
          v-if="dashboard_data.dashboard_daily_view_report"
          type="bar"
          label="بازدید"
          :info="dashboard_data.dashboard_daily_view_report"
        />
      </div>
    </section>

    <section class="dash-grid">
      <div class="dash-panel">
        <div class="dash-panel__head">
          <div class="dash-panel__title-wrap">
            <span class="dash-panel__icon dash-panel__icon--amber" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="6" width="18" height="13" rx="2.5" stroke="currentColor" stroke-width="1.8"/>
                <path d="M3 10h18" stroke="currentColor" stroke-width="1.8"/>
                <path d="M8 14h3M14 14h2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              </svg>
            </span>
            <div>
              <h2 class="dash-panel__title">درگاه‌های پرداخت</h2>
              <p class="dash-panel__hint">سهم فروش بر اساس درگاه</p>
            </div>
          </div>
        </div>
        <ul class="dash-list">
          <li
            class="dash-list__item"
            v-for="(gateway, gIdx) in dashboard_data.gateways"
            :key="'gw-' + gIdx"
          >
            <div class="dash-list__row">
              <span class="dash-list__badge dash-list__badge--amber" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 9h16v9a2 2 0 01-2 2H6a2 2 0 01-2-2V9z" stroke="currentColor" stroke-width="1.8"/>
                  <path d="M8 9V7a4 4 0 018 0v2" stroke="currentColor" stroke-width="1.8"/>
                </svg>
              </span>
              <div class="dash-list__meta">
                <span class="dash-list__name">{{ gateway.title }}</span>
                <span class="dash-list__amount" v-if="gateway.payments_sum_pay_price!=null">
                  {{ get_currency(gateway.payments_sum_pay_price) }}
                </span>
                <span class="dash-list__amount" v-else>0</span>
              </div>
            </div>
            <div class="dash-meter">
              <div
                class="dash-meter__fill dash-meter__fill--amber"
                :style="{ width: calculate_items_percent(dashboard_data.gateways,'payments_sum_pay_price',gateway.payments_sum_pay_price) + '%' }"
              ></div>
            </div>
          </li>
        </ul>
      </div>

      <div class="dash-panel">
        <div class="dash-panel__head">
          <div class="dash-panel__title-wrap">
            <span class="dash-panel__icon dash-panel__icon--rose" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9v4M12 17h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                <path d="M10.3 4.9L2.8 18a2 2 0 001.7 3h15a2 2 0 001.7-3L13.7 4.9a2 2 0 00-3.4 0z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
              </svg>
            </span>
            <div>
              <h2 class="dash-panel__title">کالاهای کم‌موجود</h2>
              <p class="dash-panel__hint">نیاز به تأمین انبار</p>
            </div>
          </div>
        </div>
        <ul class="dash-list">
          <li
            class="dash-list__item"
            v-for="(product, pIdx) in dashboard_data.order_point_products.slice(0,5)"
            :key="'op-' + pIdx"
          >
            <div class="dash-list__row">
              <span class="dash-list__badge dash-list__badge--rose" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 8.5l8-4.5 8 4.5v7l-8 4.5-8-4.5v-7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
                  <path d="M4 8.5l8 4.5 8-4.5" stroke="currentColor" stroke-width="1.8"/>
                </svg>
              </span>
              <div class="dash-list__meta">
                <span class="dash-list__name">{{ product.product.title.title }}</span>
                <span class="dash-list__amount dash-list__amount--danger">{{ product.stock }} عدد</span>
              </div>
            </div>
            <div class="dash-meter">
              <div class="dash-meter__fill dash-meter__fill--rose" style="width: 100%"></div>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="dash-panel">
      <div class="dash-panel__head">
        <div class="dash-panel__title-wrap">
          <span class="dash-panel__icon dash-panel__icon--purple" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 7h13l-1.5 8H8.5L7 7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
              <path d="M7 7L6 4H3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="9.5" cy="19" r="1.5" fill="currentColor"/>
              <circle cx="17" cy="19" r="1.5" fill="currentColor"/>
            </svg>
          </span>
          <div>
            <h2 class="dash-panel__title">آخرین سفارش‌ها</h2>
            <p class="dash-panel__hint">سفارش‌های اخیر فروشگاه</p>
          </div>
        </div>
      </div>
      <div class="dash-table-wrap">
        <CDataTableFixed
          class="mb-0 dash-table"
          hover
          :items="dashboard_data.last_orders"
          :fields="orderFields"
          head-color="light"
          no-sorting
        >
          <template #status="{item}">
            <td>
              <div class="dash-status">
                <div class="dash-status__top">
                  <strong>{{ item.statuses[0].status.title.title }}</strong>
                  <small>{{ item.statuses[0].status.title.proccess }}</small>
                </div>
                <div class="dash-meter dash-meter--sm">
                  <div
                    class="dash-meter__fill"
                    :style="`width:${item.statuses[0].status.proccess}%;background:${item.statuses[0].status.color}`"
                  ></div>
                </div>
              </div>
            </td>
          </template>

          <template #created_at="{item}">
            <td>
              <span class="dash-cell-muted">{{ get_date_time(item.created_at) }}</span>
            </td>
          </template>
          <template #name="{item}">
            <td>
              <span class="dash-cell-strong">{{ item.user.name }}</span>
            </td>
          </template>
          <template #total_price="{item}">
            <td>
              <span class="dash-cell-strong">{{ get_currency(item.total_price) }}</span>
            </td>
          </template>

          <template #operation="{item}">
            <td>
              <button
                type="button"
                class="dash-icon-btn"
                title="مشاهده سفارش"
                @click="$router.push('/dashboard/orders/info/'+item.id)"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
                  <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
                </svg>
              </button>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </section>

    <section class="dash-panel">
      <div class="dash-panel__head">
        <div class="dash-panel__title-wrap">
          <span class="dash-panel__icon dash-panel__icon--teal" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3l2.2 6.6H21l-5.4 3.9 2.1 6.5L12 16.8 6.3 20l2.1-6.5L3 9.6h6.8L12 3z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
            </svg>
          </span>
          <div>
            <h2 class="dash-panel__title">محصولات برتر</h2>
            <p class="dash-panel__hint">فروش و بازدید بر اساس بازه زمانی</p>
          </div>
        </div>
        <div class="dash-tabs" role="tablist">
          <button
            type="button"
            v-for="(value, key) in ['روزانه', 'ماهانه', 'سالانه']"
            :key="'prod-' + key"
            class="dash-tabs__btn"
            :class="{ 'is-active': value === selected_products_time }"
            @click="selected_products_time = value"
          >
            {{ value }}
          </button>
        </div>
      </div>

      <div class="dash-grid dash-grid--inner">
        <div>
          <h3 class="dash-section-label">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M3 3v18h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M7 15l4-4 3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            فروش محصولات
          </h3>
          <ul class="dash-list">
            <li
              class="dash-list__item"
              v-for="(item, idx) in products_time_list(1)"
              :key="'ps-' + idx"
            >
              <div class="dash-list__row">
                <div class="dash-list__meta dash-list__meta--full">
                  <span class="dash-list__name">{{ item.title.title }}</span>
                  <span class="dash-list__amount">{{ item.orders_count }}</span>
                </div>
              </div>
              <div class="dash-meter">
                <div
                  class="dash-meter__fill dash-meter__fill--teal"
                  :style="{ width: Math.min(100, Number(item.orders_count) || 0) + '%' }"
                ></div>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <h3 class="dash-section-label">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
            </svg>
            بازدید محصولات
          </h3>
          <ul class="dash-list">
            <li
              class="dash-list__item"
              v-for="(item, idx) in products_time_list(2)"
              :key="'pv-' + idx"
            >
              <div class="dash-list__row">
                <div class="dash-list__meta dash-list__meta--full">
                  <span class="dash-list__name">{{ item.title.title }}</span>
                  <span class="dash-list__amount">{{ item.views_count }}</span>
                </div>
              </div>
              <div class="dash-meter">
                <div
                  class="dash-meter__fill dash-meter__fill--purple"
                  :style="{ width: Math.min(100, Number(item.views_count) || 0) + '%' }"
                ></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="dash-panel">
      <div class="dash-panel__head">
        <div class="dash-panel__title-wrap">
          <span class="dash-panel__icon dash-panel__icon--blue" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="3.5" stroke="currentColor" stroke-width="1.8"/>
              <path d="M5 19.5c1.5-3.2 4-4.8 7-4.8s5.5 1.6 7 4.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </span>
          <div>
            <h2 class="dash-panel__title">آخرین مشتریان</h2>
            <p class="dash-panel__hint">کاربران تازه‌ثبت‌نام‌شده</p>
          </div>
        </div>
      </div>
      <div class="dash-table-wrap">
        <CDataTableFixed
          class="mb-0 dash-table"
          hover
          :items="dashboard_data.last_users"
          :fields="userFields"
          head-color="light"
          no-sorting
        >
          <template #created_at="{item}">
            <td>
              <span class="dash-cell-muted">{{ get_date_time(item.created_at) }}</span>
            </td>
          </template>
          <template #operation="{item}">
            <td class="py-2">
              <button
                type="button"
                class="dash-icon-btn dash-icon-btn--outline"
                title="سفارش‌های مشتری"
                @click="goCustomerOrders(item)"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
                  <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
                </svg>
              </button>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </section>
  </div>
</template>

<script>
import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from './widgets/WidgetsDropdown'
import WidgetsBrand from './widgets/WidgetsBrand'
import axios from "axios";
import NewChartJs from "@/views/charts/NewChartJs.vue";

export default {
  name: 'Dashboard',
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    NewChartJs
  },
  data() {
    return {
      selected_sale_time: 'روزانه',
      selected_products_time: 'روزانه',

      userFields: [
        {key: 'id', label: '#', _classes: 'text-center'},
        {key: 'name', label: 'نام و نام خانودگی'},
        {key: 'created_at', label: 'تاریخ ثبت نام', _classes: 'text-center'},
        {key: 'phone', label: 'شماره همراه', _classes: 'text-center'},
        {key: 'orders_count', label: 'تعداد سفارش', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      orderFields: [
        {key: 'id', label: '#', _classes: 'text-center'},
        {key: 'name', label: 'مشتری'},
        {key: 'created_at', label: 'تاریخ ثبت', _classes: 'text-center'},
        {key: 'status', label: 'وضعیت', _classes: 'text-center'},
        {key: 'total_price', label: 'مبلغ', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      dashboard_data: {},
    }
  },
  mounted() {
    this.get_dashboard_data();
  },
  methods: {
    goCustomerOrders(item) {
      this.$router.push({path: '/dashboard/orders/list/'+item.id});
    },
    products_time_list(type){
      if(type==1){
        if(this.selected_products_time=='روزانه'){
          return this.dashboard_data.today_order_products
        }
        if(this.selected_products_time=='ماهانه'){
          return this.dashboard_data.month_order_products
        }
        if(this.selected_products_time=='سالانه'){
          return this.dashboard_data.all_order_products
        }
      }
      if(type==2){
        if(this.selected_products_time=='روزانه'){
          return this.dashboard_data.today_view_products
        }
        if(this.selected_products_time=='ماهانه'){
          return this.dashboard_data.month_view_products
        }
        if(this.selected_products_time=='سالانه'){
          return this.dashboard_data.all_view_products
        }
      }
    },
    get_dashboard_data() {
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();

      axios.post('/api/admin/dashboard_data', formData, {}).then(function (response) {

        var contents = response.data;

        self.dashboard_data = contents;

      })
          .catch(function (error) {
            console.log(error);
          });

    },
  }
}
</script>

<style scoped lang="scss">
/* Spacing scale: 8 / 12 / 16 / 20 / 24 */
.dash {
  padding: 0 0 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dash-hero {
  padding: 0;
  margin: 0;
}

.dash-hero__title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: var(--panel-text, #364a63);
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.dash-hero__sub {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--panel-muted, #8094ae);
  line-height: 1.5;
}

.dash-period {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.dash-period__item {
  background: var(--panel-surface, #fff);
  border-radius: 14px;
  padding: 14px 16px;
  border: 1px solid var(--panel-border, rgba(128, 148, 174, 0.12));
  box-shadow: var(--panel-shadow);
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.dash-period__label {
  font-size: 12px;
  color: var(--panel-muted, #8094ae);
  line-height: 1.4;
}

.dash-period__value {
  font-size: 14px;
  color: var(--panel-text, #364a63);
  font-weight: 700;
  word-break: break-word;
  line-height: 1.4;
}

.dash-period__bar {
  display: block;
  height: 3px;
  border-radius: 99px;
  margin-top: 2px;
  width: 36%;
}

.dash-period__item--today .dash-period__bar { background: #3b82f6; }
.dash-period__item--month .dash-period__bar { background: #06b6d4; }
.dash-period__item--last .dash-period__bar { background: #f59e0b; }
.dash-period__item--year .dash-period__bar { background: #f43f5e; }

.dash-panel {
  background: var(--panel-surface, #fff);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid var(--panel-border, rgba(128, 148, 174, 0.12));
  box-shadow: var(--panel-shadow);
}

.dash-panel__head {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.dash-panel__head--sub {
  margin-top: 0;
}

.dash-panel__title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.dash-panel__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dash-panel__icon svg {
  width: 20px;
  height: 20px;
}

.dash-panel__icon--purple { background: rgba(6, 182, 212, 0.14); color: #06b6d4; }
.dash-panel__icon--teal { background: rgba(20, 184, 166, 0.14); color: #14b8a6; }
.dash-panel__icon--amber { background: rgba(245, 158, 11, 0.14); color: #f59e0b; }
.dash-panel__icon--rose { background: rgba(244, 63, 94, 0.14); color: #f43f5e; }
.dash-panel__icon--blue { background: rgba(59, 130, 246, 0.14); color: #3b82f6; }

.dash-panel__title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--panel-text, #364a63);
  line-height: 1.35;
}

.dash-panel__hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--panel-muted, #8094ae);
  line-height: 1.4;
}

.dash-panel__divider {
  height: 1px;
  background: var(--panel-border, rgba(128, 148, 174, 0.16));
  margin: 20px 0;
}

.dash-tabs {
  display: flex;
  gap: 4px;
  background: var(--panel-surface-2, #f3f5f9);
  padding: 4px;
  border-radius: 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.dash-tabs::-webkit-scrollbar {
  display: none;
}

.dash-tabs__btn {
  flex: 1 0 auto;
  min-width: 72px;
  border: 0;
  background: transparent;
  color: var(--panel-nav, #6e82a5);
  font-size: 12px;
  font-family: inherit;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}

.dash-tabs__btn.is-active {
  background: var(--panel-surface, #fff);
  color: var(--panel-accent, var(--accent));
  box-shadow: 0 1px 4px rgba(31, 43, 58, 0.08);
}

.dash-chart {
  margin-top: 0;
  min-height: 220px;
}

.dash-chart >>> canvas,
.dash-chart ::v-deep canvas {
  max-width: 100% !important;
}

.dash-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.dash-grid--inner {
  gap: 20px;
}

.dash-section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
  color: var(--panel-text, #526484);
}

.dash-section-label svg {
  width: 16px;
  height: 16px;
  color: var(--panel-accent, var(--accent));
}

.dash-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dash-list__item {
  min-width: 0;
}

.dash-list__row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.dash-list__badge {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dash-list__badge svg {
  width: 16px;
  height: 16px;
}

.dash-list__badge--amber { background: var(--surface-3); color: #f59e0b; }
.dash-list__badge--rose { background: var(--surface-3); color: #f43f5e; }

.dash-list__meta {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.dash-list__meta--full {
  width: 100%;
}

.dash-list__name {
  font-size: 13px;
  color: var(--panel-text, #364a63);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

.dash-list__amount {
  font-size: 12px;
  font-weight: 700;
  color: var(--panel-nav, #526484);
  white-space: nowrap;
  flex-shrink: 0;
}

.dash-list__amount--danger {
  color: #f43f5e;
}

.dash-meter {
  height: 6px;
  background: var(--panel-meter, #eef1f6);
  border-radius: 99px;
  overflow: hidden;
}

.dash-meter--sm {
  height: 5px;
  margin-top: 6px;
}

.dash-meter__fill {
  height: 100%;
  border-radius: 99px;
  transition: width 0.35s ease;
  min-width: 0;
}

.dash-meter__fill--amber { background: linear-gradient(90deg, #fbbf24, #f59e0b); }
.dash-meter__fill--rose { background: linear-gradient(90deg, #fb7185, #f43f5e); }
.dash-meter__fill--teal { background: linear-gradient(90deg, #2dd4bf, #14b8a6); }
.dash-meter__fill--purple { background: linear-gradient(90deg, #60a5fa, #2563eb); }

.dash-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0;
  padding: 0;
}

.dash-table >>> table,
.dash-table ::v-deep table {
  min-width: 640px;
  margin-bottom: 0;
}

.dash-table >>> thead th,
.dash-table ::v-deep thead th {
  background: var(--panel-surface-2, #f7f8fb) !important;
  color: var(--panel-muted, #6e82a5);
  font-size: 12px;
  font-weight: 700;
  border: 0 !important;
  white-space: nowrap;
  padding: 12px !important;
}

.dash-table >>> tbody td,
.dash-table ::v-deep tbody td {
  vertical-align: middle;
  border-color: var(--panel-border, rgba(128, 148, 174, 0.12)) !important;
  padding: 12px !important;
  font-size: 13px;
  color: var(--panel-text, #364a63);
}

.dash-table >>> tbody tr:hover,
.dash-table ::v-deep tbody tr:hover {
  background: var(--panel-accent-soft, #f4f4f5) !important;
}

.dash-cell-muted {
  color: var(--panel-muted, #8094ae);
  font-size: 12px;
}

.dash-cell-strong {
  font-weight: 700;
  color: var(--panel-text, #364a63);
}

.dash-status__top {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: baseline;
}

.dash-status__top strong {
  font-size: 12px;
  color: var(--panel-text, #364a63);
}

.dash-status__top small {
  font-size: 11px;
  color: var(--panel-muted, #8094ae);
}

.dash-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 0;
  background: var(--panel-accent, var(--accent));
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.dash-icon-btn svg {
  width: 18px;
  height: 18px;
}

.dash-icon-btn:hover {
  background: var(--accent);
  box-shadow: 0 6px 14px -6px rgba(17, 17, 17, 0.7);
}

.dash-icon-btn:active {
  transform: scale(0.96);
}

.dash-icon-btn--outline {
  background: transparent;
  color: var(--panel-accent, var(--accent));
  border: 1.5px solid rgba(17, 17, 17, 0.35);
}

.dash-icon-btn--outline:hover {
  background: var(--panel-accent-soft, #f4f4f5);
  box-shadow: none;
}

@media (min-width: 768px) {
  .dash {
    gap: 20px;
    padding-bottom: 32px;
  }

  .dash-hero__title {
    font-size: 24px;
  }

  .dash-period {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  .dash-period__item {
    padding: 16px;
  }

  .dash-period__value {
    font-size: 15px;
  }

  .dash-panel {
    padding: 20px;
    border-radius: 16px;
  }

  .dash-panel__head {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 16px;
  }

  .dash-tabs {
    width: auto;
    flex: 0 0 auto;
  }

  .dash-tabs__btn {
    flex: 0 0 auto;
    font-size: 13px;
    padding: 8px 14px;
  }

  .dash-grid {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .dash-chart {
    min-height: 260px;
  }
}
</style>
